import { createStore, applyMiddleware /*, compose */ } from 'redux';

export default function configureStore(initialState, middlewares = [], reducer) {
  const enhancer = applyMiddleware(...middlewares);
  return createStore(reducer, initialState, enhancer);
}



// WEBPACK FOOTER //
// ./app/store/configureStore.prod.js